import {
  PushNotificationType,
  Schedule,
} from "../_shared/pushNotifications/types";
import { handleTableTime } from "../NewPushNotification/utils";
import { subHours } from "date-fns";

export const setSuccessColumn = (schedule: Schedule): string => {
  const total =
    schedule.numSuccess + schedule.numFailure - schedule.numOptedOut;

  switch (true) {
    case total !== 0 && schedule.status === "COMPLETED":
      return ((schedule.numSuccess / total) * 100).toFixed(2) + "%";
    case total === 0 && schedule.status === "INPROGRESS":
      return "Awaiting Completion";
    case total !== 0 && schedule.status === "INPROGRESS":
      return ((schedule.numSuccess / total) * 100).toFixed(2) + "%";
    case schedule.status === "SCHEDULED":
      return "Scheduled";
    case schedule.status === "STOP":
      return "STOPPED";
    default:
      return "";
  }
};

export const createTableRowItem = (
  scheduleDb: PushNotificationType,
  schedule: Schedule
) => {
  // Conditionally adjust the `dueOn` time only if the status is "STOP"
  const adjustedDueOn =
    schedule.status === "STOP"
      ? subHours(new Date(schedule.dueOn), 1)
      : new Date(schedule.dueOn);

  return {
    id: scheduleDb.id,
    ScheduleId: schedule.scheduleId,
    Name: scheduleDb.name,
    Title: scheduleDb.title,
    Body: scheduleDb.body,
    Created: handleTableTime(schedule.createdOn),
    SendDate: handleTableTime(adjustedDueOn.toISOString()), // Format the adjusted or original dueOn date
    Status: schedule.status,
    Success: setSuccessColumn(schedule),
  };
};
